<div class="home-shell container-fluid">
  <div class="home-banner">
    <div class="banner-overlay"></div>

    <div class="banner-content">
      <div class="banner-kicker">SLB Internal Platform</div>

      <h1>VMI Store Workspace</h1>

      <p>
        A modern internal workspace for order visibility and streamlined request creation.
      </p>

      <div class="banner-actions">
        <button class="btn btn-banner-primary" [routerLink]="'/orders'">
          Open Order List
        </button>
        <button class="btn btn-banner-outline" [routerLink]="'/productlist'">
          Create Order
        </button>
      </div>
    </div>

    <div class="banner-side-card">
      <div class="side-card-label">Platform Overview</div>

      <div class="side-card-row">
        <span>Environment</span>
        <strong>SLB Workspace</strong>
      </div>

      <div class="side-card-row">
        <span>Primary Flow</span>
        <strong>Order Management</strong>
      </div>

      <div class="side-card-row">
        <span>Access</span>
        <strong>Fast & Structured</strong>
      </div>
    </div>
  </div>

  <div class="floating-panels row justify-content-center">
    <div class="col-lg-6 col-md-6 mb-4">
      <div class="floating-card floating-card-blue" [routerLink]="'/orders'">
        <div class="floating-top-line"></div>
        <div class="floating-icon">
          <i class="fas fa-list-ul"></i>
        </div>
        <h3>Order List</h3>
        <p>
          Review submitted orders, monitor progress, and keep your workflow organized.
        </p>
        <div class="floating-link">Go to Order List</div>
      </div>
    </div>

    <div class="col-lg-6 col-md-6 mb-4">
      <div class="floating-card" [routerLink]="'/productlist'">
        <div class="floating-top-line"></div>
        <div class="floating-icon">
          <i class="fas fa-cart-plus"></i>
        </div>
        <h3>Create Order</h3>
        <p>
          Start a new request quickly and move it into the approval process.
        </p>
        <div class="floating-link">Start New Order</div>
      </div>
    </div>
  </div>
</div>
